import { render, staticRenderFns } from "./InformationTab.vue?vue&type=template&id=730cdf4a&scoped=true&"
import script from "./InformationTab.vue?vue&type=script&lang=ts&"
export * from "./InformationTab.vue?vue&type=script&lang=ts&"
import style0 from "./InformationTab.vue?vue&type=style&index=0&id=730cdf4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730cdf4a",
  null
  
)

export default component.exports